// Preschool teachers' days off for 2026-27, copied from the "Preschool
// Teachers' Calendar 26-27" tab of the Annual Calendar 26-27 sheet (Satya,
// 22 Oct: "use this as a calendar, it is not a dynamic calendar"). Preschool
// holidays and optional holidays are listed; training days, events and
// playdates are working days. 28–30 Sep (autumn break for children) is
// teacher training, so it is not here. If the sheet changes, change this list.
export const PRESCHOOL_HOLIDAYS = new Set([
  '2026-08-15', // Independence Day
  '2026-09-14', // Ganesh Chaturthi
  '2026-09-27', // Autumn break
  '2026-10-01', // Holiday for teachers
  '2026-10-02', // Gandhi Jayanti
  '2026-10-03',
  '2026-10-04',
  '2026-10-20', // Vijaya Dashami
  '2026-11-01', // Karnataka Rajyotsava
  '2026-11-10', // Diwali
  '2026-12-25', // Optional cultural holiday
  '2026-12-26',
  '2026-12-27',
  '2026-12-28',
  '2026-12-29',
  '2026-12-30',
  '2026-12-31',
  '2027-01-01',
  '2027-01-02',
  '2027-01-03',
  '2027-01-15', // Sankranti
  '2027-01-26', // Republic Day
  '2027-03-09', // Eid-ul-Fitr (tentative, 9th or 10th)
  '2027-03-22', // Holi
  '2027-03-26', // Optional — Good Friday
  '2027-04-07', // Ugadi
  '2027-05-01', // May Day
  '2027-05-17' // Optional — Bakrid
])
